export enum InputTypeEnum {
  TEXT = "text",
  PASSWORD = "password",
}